import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('PlayGameModal').create(({ theme }) => ({
  wrapper: {
    position: 'fixed',
    zIndex: '50',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  root: {
    position: 'absolute',
    width: '90%',
    zIndex: 20,
    minHeight: '156px',
    bottom: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px',
    borderRadius: theme.sizes.radiuses.l,
    background: theme.colors.button.secondary.background,
  },

  textContainer: {
    display: 'flex',
    gap: '20px',
    span: {
      fontWeight: '450',
      fontSize: theme.sizes.texts.fontSize.s,
    },
  },

  buttonContainer: {
    display: 'flex',
    gap: '16px',
    padding: '0px 4px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  confirmButton: {
    background: 'transparent',
    borderRadius: '8px',
    boxShadow: 'none',
    border: '1px solid',
    borderColor: theme.colors.text.success,
    color: theme.colors.text.success,
    fontWeight: 560,
  },

  cancelButton: {
    background: 'rgba(255, 255, 255, 0.16)',
    boxShadow: 'none',
    borderRadius: '8px',
    fontWeight: 560,
  },
}))
